module.exports = __webpack_public_path__ + "img/quickshape-jp.fa8a029.jpg";